<template>
  <v-dialog v-model="dialog" persistent max-width="450px">
    <v-card class="department-dialog">
      <v-card-title class="department-dialog__header">
        <span class="department-dialog__icon"><v-icon>mdi-pencil-outline</v-icon></span>
        <div><small>Team organization</small><strong>Edit department</strong></div>
        <v-spacer></v-spacer><v-btn icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pt-5">
        <p class="department-dialog__help">Update the department name. Assigned employees will stay in this department.</p>
        <v-row>
          <v-col cols="12" sm="12">
            <v-text-field
              outlined
              :hide-details="nameErrors.length === 0"
              dense
              @keyup.enter="submit"
              :error-messages="nameErrors"
              v-model="Department.name"
              label="Department name"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="department-dialog__actions">
        <v-spacer></v-spacer>
        <v-btn text @click="close()">Cancel</v-btn>
        <v-btn color="primary" rounded :loading="loading" @click="submit()"
          ><v-icon left small>mdi-check</v-icon>Save changes</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DepartmentService from "../service.js";
import _ from "lodash";

const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  props: {
    editDialog: {
      default: false
    },
    editDepartment: {
      type: Object
    }
  },
  name: "update-Department",
  data() {
    return {
      loading: false,
      dialog: false,
      Department: {
        name: null
      }
    };
  },
  mixins: [validationMixin],
  validations: {
    Department: {
      name: {
        required
      }
    }
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.Department.name.$dirty) return errors;
      if (!this.$v.Department.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    }
  },
  watch: {
    editDialog(val) {
      this.Department = _.clone(this.editDepartment)
      this.dialog = val;
    }
  },
  methods: {
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.Department = {
        name: null,
      };
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$toast.error("Invalid Fields", {
          timeout: 2000,
        });
      } else {
        this.loading = true;
        this.Department.name = this.Department.name.charAt(0).toUpperCase() + this.Department.name.slice(1)
        return DepartmentService.update(this.Department.id, this.Department)
          .then(result => {
            if (result.status) {
              this.$toast.success("Department is updated", {
                timeout: 2000,
              });
              this.loading = false;
              this.$emit("submit");
              this.close();
            }
          })
          .catch(err => {
            this.loading = false;
            this.$toast.error(err.data ? err.data.message : "Error", {
              timeout: 2000,
            });
          });
      }
    }
  }
};
</script>

<style scoped>
.department-dialog {
  background: var(--v-surface-base) !important;
  border-radius: 20px !important;
  color: var(--v-textPrimary-base);
}

.department-dialog__header {
  border-bottom: 1px solid var(--v-border-base);
  gap: 11px;
  padding: 18px;
}

.department-dialog__icon {
  align-items: center;
  background: rgba(96, 165, 250, 0.12);
  border-radius: 12px;
  display: flex;
  height: 42px;
  justify-content: center;
  width: 42px;
}

.department-dialog__icon .v-icon {
  color: var(--v-primary-base);
}

.department-dialog__header small,
.department-dialog__header strong {
  display: block;
}

.department-dialog__header small,
.department-dialog__help {
  color: var(--v-textSecondary-base);
  font-size: 0.72rem;
}

.department-dialog__help {
  margin-bottom: 16px;
}

.department-dialog__actions {
  border-top: 1px solid var(--v-border-base);
  padding: 12px 16px;
}
</style>
